import React from 'react'
import { BasicButton } from '../BasicButton'
import { useGeneral } from '../../hooks/useGeneral'

export const Prize = ({ prize, className, style, title }) => {
  return (
    <div className={className} style={style}>
      <span>{title}</span>
      <span key={prize} className="prize-title">
        {prize}
      </span>
    </div>
  )
}

export const PrizeContainer = ({ totalPrize, className, onAction }) => {
  const { recalculate, averagePrice } = useGeneral()

  return (
    <div className={`prize-container ${className}`}>
      <Prize
        title={averagePrice}
        prize={totalPrize}
        className="average-prize"
      />
      <BasicButton onClick={onAction} text={recalculate} />
    </div>
  )
}
